import {
  TFutureGreenFeePreviewParticipant,
  TFuturePowerCartPreviewParticipant,
} from "api/rpc/2024-04/facilityAdmin/teesheet/booking";

export type TFutureBookingPricingParticipant = {
  participant_id: number;
  tee_time_date: string;
  tee_time_start_time: string;
  course_title: string | null;
  current_variant_title: string | null;
  current_price: number | null;
  proposed_variant_title: string | null;
  proposed_price: number | null;
  eligible: boolean;
  skip_reason: string | null;
};

export type TFutureBookingPricingSectionId = "green_fee" | "power_cart";

export type TFutureBookingPricingSection = {
  id: TFutureBookingPricingSectionId;
  title: string;
  feeColumnLabel: string;
  participants: TFutureBookingPricingParticipant[];
  selectedParticipantIds: number[];
};

export function mapGreenFeePreviewParticipant(
  participant: TFutureGreenFeePreviewParticipant,
): TFutureBookingPricingParticipant {
  return {
    participant_id: participant.participant_id,
    tee_time_date: participant.tee_time_date,
    tee_time_start_time: participant.tee_time_start_time,
    course_title: participant.course_title,
    current_variant_title: participant.current_green_fee_variant_title,
    current_price: participant.current_green_fee_price,
    proposed_variant_title: participant.proposed_green_fee_variant_title,
    proposed_price: participant.proposed_green_fee_price,
    eligible: participant.eligible,
    skip_reason: participant.skip_reason,
  };
}

export function mapPowerCartPreviewParticipant(
  participant: TFuturePowerCartPreviewParticipant,
): TFutureBookingPricingParticipant {
  return {
    participant_id: participant.participant_id,
    tee_time_date: participant.tee_time_date,
    tee_time_start_time: participant.tee_time_start_time,
    course_title: participant.course_title,
    current_variant_title: participant.current_power_cart_variant_title,
    current_price: participant.current_power_cart_price,
    proposed_variant_title: participant.proposed_power_cart_variant_title,
    proposed_price: participant.proposed_power_cart_price,
    eligible: participant.eligible,
    skip_reason: participant.skip_reason,
  };
}

export const FUTURE_BOOKING_PRICING_SECTION_ORDER: TFutureBookingPricingSectionId[] = ["green_fee", "power_cart"];

export function createEmptySelectedBySection(): Record<TFutureBookingPricingSectionId, number[]> {
  return {
    green_fee: [],
    power_cart: [],
  };
}
